export default __webpack_public_path__ + "static/media/sidebar-orange.3041f56e.png";